import { Footer } from '@domgen/base-design-system-2.0/atoms/Footer';
import { HeaderCobranded } from '@domgen/base-design-system-2.0/atoms/HeaderCobranded';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { smoothScrollIntoView } from '@domgen/base-design-system-2.0/animation/smoothScrollIntoView';
import { useAppContext } from './context/AppContext';
import { store } from './store/store';
import pdfCarePlus from './assets/documents/HIS_USWTCCP_0626_31_100.pdf';
import pdfReplacementCare from './assets/documents/HIS_USWTCRC_0626_03_100.pdf';

export const Layout = () => {
  const location = useLocation();
  const { clientLogo, getRouteFromPath } = useAppContext();
  const clientName = import.meta.env.VITE_CLIENT_FRIENDLY_NAME.trim();
  const navigate = useNavigate();
  const links = [
    {
      text: `${clientName} Care Plus`,
      href: pdfCarePlus,
    },
    {
      text: `${clientName} Replacement Care`,
      href: pdfReplacementCare,
    },
    {
      text: `${clientName} Product Support`,
      href: `https://www.hisense-usa.com/support`,
    },
    { text: `Terms of Use`, href: 'https://www.domesticandgeneral.com/us/terms-and-conditions' },
    {
      text: `Domestic & General privacy notice`,
      href: 'https://www.domesticandgeneral.com/us/security-privacy',
    },
    {
      text: `${clientName} privacy notice`,
      href: 'https://www.hisense-usa.com/privacy-policy',
    },
    { text: `Cookies notice`, href: 'https://www.domesticandgeneral.com/us/cookies' },
  ];

  const addendum = `Hisense and Domestic & General are independent
          corporations and not part of the same group. Domestic & Generals use of Hisense trademark
          is with permission. The plans are service contracts and not insurance.`;

  useEffect(() => {
    smoothScrollIntoView(0);
  }, [location.pathname]);

  useEffect(() => {
    const sub = store.on('navigate', ({ path, replace }) => {
      navigate(path, { replace });
    });
    return sub.unsubscribe;
  }, [navigate]);

  const getPageTitle = () => {
    const route = getRouteFromPath(location.pathname);
    if (!route) return `${clientName} Registration`;
    return `${clientName} Registration - ${route.title}`;
  };

  return (
    <div className="flex flex-col min-h-screen">
      <HeaderCobranded
        clientIcon={
          <NavLink aria-label="Hisense Registration homepage" to="/">
            {clientLogo}
          </NavLink>
        }
        clientName={clientName}
      />
      <main className="grow flex flex-col">
        <title>{getPageTitle()}</title>
        <Outlet />
      </main>
      <Footer client={`${clientName} Care`} links={links} addendum={addendum} />
    </div>
  );
};
